import qs from 'qs';

const getGoogleClientId = (gaInstance) => {
  if (!gaInstance) {
    return null;
  }

  let clientId;
  gaInstance(() => {
    clientId = gaInstance.getAll()[0].get('clientId');
  });
  return clientId;
};

export async function googleClientId() {
  await new Promise((r) => setTimeout(r, 1000));
  if (typeof ga === 'undefined') {
    return null;
  }

  return getGoogleClientId(ga);
}

export const getUtmParams = (googleId) => {
  let utmUrlParameters = {};
  if (window.location.search.length > 0) {
    utmUrlParameters = qs.parse(window.location.search.split('?')[1]);
  }
  if (googleId) {
    utmUrlParameters.google_optimize_client_id = googleId;
  }
  console.log('utmUrlParameters', utmUrlParameters);
  return utmUrlParameters;
};
